import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import React, { useState, useEffect } from "react";
import axios from "axios";
import Wrapper from "../../../components/UI/Wrapper";
import "../../../pages/SalesMasterPages/PriceCalculator/PriceCalculator.css";
import NumericInput from "../../../components/NumericInput/NumericInput";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const RateCalculatorIndia = () => {
    const location = useLocation();
    const baseAPI = process.env.REACT_APP_API_URL;
    const heading = "Quotation Builder (India)";
    const relocation_id = location.state?.relocation_id;
    const Relocation_ID = decryptRelocationID(relocation_id);
    const [decryptionError, setDecryptionError] = useState(false);
    const [descriptionsName, setDescriptionsName] = useState([]);
    const [originAirport, setOriginAirport] = useState([]);
    const [destinationAirport, setDestinationAirport] = useState([]);
    const [locations, setLocations] = useState([]);
    const [hasSaved, setHasSaved] = useState(false);   // whether saved at least once
    const [hasRows, setHasRows] = useState(false);     // whether user added rows
    const [adjustment, setAdjustment] = useState(0);
    const [adjustmentBase, setAdjustmentBase] = useState(0);
    const [adjustmentGST, setAdjustmentGST] = useState(0);
    const [finalAfterAdjustment, setFinalAfterAdjustment] = useState(0);
    const [rows, setRows] = useState([]);
    const [totals, setTotals] = useState({
        beforeDiscount: 0,
        discount: 0,
        gst: 0,
        afterAll: 0,
    });
    const [paymentPercent, setPaymentPercent] = useState(0); // percent user will enter
    const [paymentGatewayCharges, setPaymentGatewayCharges] = useState(0); // calculated amount
    const [finalAfterGateway, setFinalAfterGateway] = useState(0); // totals after adding gateway charges

    const navigate = useNavigate();

    function decryptRelocationID(ciphertext) {
        try {
            const bytes = CryptoJS.AES.decrypt(
                decodeURIComponent(ciphertext),
                "dbbworldwidepvtltd"
            );
            return bytes.toString(CryptoJS.enc.Utf8);
        } catch (error) {
            console.error("Error decrypting Relocation_ID:", error);
            setDecryptionError(true);

            return null;
        }
    }

    const [firstItem, setFirstItem] = useState({
        relocationdetail_id: "",
        origin_city: "",
        destination_city: "",
        mode_of_transport: "",
        relocation_id: "",
        relocation_detail: "",
        origin_city1: "",
        destination_city1: "",
        delivery_type: "",
        delivery_type_name: "",
        ServiceTypeName: "",
        petbreedtype: "",
        job_type: "",
        name: "",
        origin_port: "",
        destination_port: "",
        laneName: "",
        chargeable_wt: "",
        location_id: "",
        total: "",
        buying: "",
        due_carrier: "",
        other_charges: "",
        amount_in_aed: "",
    });

    function encryptRelocationID(Relocation_ID, key) {
        const ciphertext = CryptoJS.AES.encrypt(Relocation_ID.toString(), key).toString();
        return encodeURIComponent(ciphertext);
    }
    const handleQuotation = (e) => {
        const key = 'dbbworldwidepvtltd';
        const encryptedRelocationID = encryptRelocationID(Relocation_ID, key);
        const url = `/EstimateIndia?Relocation_ID=${encryptedRelocationID}`;
        window.open(url, '_blank');



    };

    useEffect(() => {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        if (storedToken) {
            axios
                .get(
                    `${baseAPI}userget/GetSOWRelocationDetailNew?relocation_id=` +
                    Relocation_ID,
                    {
                        headers: {
                            Authorization: `Bearer ${storedToken}`,
                        },
                    }
                )
                .then((response) => {
                    const data = response.data.data;
                    setFirstItem(data);

                    if (data.amount_in_inr) {
                        setTotals({
                            beforeDiscount: parseFloat(data.amount_in_inr) || 0,
                            discount: parseFloat(data.total_discount) || 0,
                            gst: parseFloat(data.total_gst) || 0,
                            afterAll: parseFloat(data.total) || 0,
                        });
                        setAdjustment(parseFloat(data.adjustment) || 0);
                        setFinalAfterAdjustment(parseFloat(data.finalAfterAdjustment) || 0);
                        setAdjustmentGST(parseFloat(data.adjustmentGST) || 0);
                        setAdjustmentBase(parseFloat(data.adjustmentBase) || 0);
                        setPaymentPercent(parseFloat(data.paymentPercent) || 0);
                        setPaymentGatewayCharges(parseFloat(data.paymentGatewayCharges) || 0);
                        setFinalAfterGateway(parseFloat(data.finalAfterGateway) || 0);
                    }

                    if (data.origin_port && data.destination_port) {
                        fetchLane(data.origin_port, data.destination_port);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching user detail:", error);
                });
            fetchSow(storedToken, Relocation_ID);
            fetchDescriptionsName();
            fetchAirport();
            fetchLocation();
        }
    }, []);

    const fetchLocation = async () => {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        try {
            const response = await axios.get(
                `${baseAPI}userget/GetLocation?location_id=0`,
                {
                    headers: { Authorization: `Bearer ${storedToken}` },
                }
            );
            setLocations(response.data.data || []);
        } catch (error) {
            console.error("Error fetching india location:", error);
            setLocations([]);
        }
    };

    const fetchDescriptionsName = async () => {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        try {
            const response = await axios.get(
                `${baseAPI}userget/MrpDescription?desc_id=0`,
                {
                    headers: { Authorization: `Bearer ${storedToken}` },
                }
            );
            setDescriptionsName(response.data.data || []);
        } catch (error) {
            console.error("Error fetching description names:", error);
            setDescriptionsName([]);
        }
    };

    const fetchSow = async (storedToken, Relocation_ID) => {
        try {
            const response = await axios.get(
                `${baseAPI}userget/GetSOWIndia?relocation_id=${Relocation_ID}`,
                {
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                    },
                }
            );
            if (response.data.data?.length > 0) {
                setRows(response.data.data);
                setHasRows(true);
                setHasSaved(true);  // ✅ treat as already saved
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    // const handleCheckHistory = () => {
    //     navigate("/CheckHistory", { state: { Relocation_ID } });
    // };


    // const handleCheckHistory = (e) => {
    //     e.preventDefault();
    //     window.open(`/CheckHistory?Relocation_ID=${Relocation_ID}`, "_blank");
    // };


    const handleCheckHistory = (e) => {
        e.preventDefault();
        localStorage.setItem("lead_id_for_estimate", Relocation_ID);
        window.open("/CheckHistory", "_blank");
    };

    const handleAddRow = () => {
        setRows([
            ...rows,
            {
                desc_id: 0,
                mrpsheet_id: 0,
                description_name: "",
                quantity: 0,
                amount_in_inr: 0,
                Rate_Gst: 0,
                total: 0,
                hsn_sac: "",
                gst_rate: 0,
                total_amount: 0,
                scope_of_service: "",
                discount: 0,
            },
        ]);
        setHasRows(true);
    };

    const handleDeleteRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
        calculateSubTotal(updatedRows);
    };

    const handleSelectChange = async (e, index) => {
        const selectedDescId = parseInt(e.target.value, 10);
        const storedToken = JSON.parse(localStorage.getItem("token"));
        const locationId = firstItem.location_id;
        const lane = firstItem.laneName;
        const chargeable_wt = firstItem.chargeable_wt;
        const buying = firstItem.buying || 0;
        const due_carrier = firstItem.due_carrier || 0;
        const other_charges = firstItem.other_charges || 0;


        try {
            // ✅ Call API with desc_id + location_id
            const response = await axios.get(
                `${baseAPI}userget/GetMrpSheetByDesc?desc_id=${selectedDescId}&location=${locationId}&lane=${lane}&chargeable_wt=${chargeable_wt}&buying=${buying}&due_carrier=${due_carrier}&other_charges=${other_charges}`,
                {
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                    },
                }
            );

            const data = response.data?.data?.[0]; // Assuming API returns an array

            if (data) {
                setRows((prevRows) => {
                    const updatedRows = prevRows.map((row, i) =>
                        i === index
                            ? {
                                ...row,
                                desc_id: selectedDescId,
                                mrpsheet_id: data.mrpsheet_id,
                                description:
                                    descriptionsName.find((d) => d.desc_id === selectedDescId)
                                        ?.description_name || "",
                                quantity: 1, // default
                                amount_in_inr: data.rate,
                                gst_rate: data.gst_rate,
                                total: 1 * data.rate * (1 + data.gst_rate / 100),
                                gst_amount: 1 * data.rate * (data.gst_rate / 100),
                                location: locationId,
                                scope_of_service: "",
                                discount: 0,
                                total_amount: data.rate, // initial taxable amount

                            }
                            : row
                    );

                    calculateSubTotal(updatedRows);
                    return updatedRows;
                });
            } else {
                alert("No MRP details found for this selection.");
            }
        } catch (error) {
            console.error("Error fetching MRP details:", error);
            alert("Failed to fetch MRP details. Try again.");
        }
    };

    const handleInputChange = (index, field, value) => {
        setRows((prevRows) => {
            const updatedRows = prevRows.map((row, i) => {
                if (i === index) {
                    const updatedRow = { ...row, [field]: value };
                    const { baseAmount, discountAmount, total_amount, gstAmount, total } = calculateRowValues(updatedRow);
                    return {
                        ...updatedRow,
                        baseAmount,
                        discountAmount,
                        total_amount: total_amount,
                        gst_amount: gstAmount,
                        total,
                    };
                }
                return row;
            });

            calculateSubTotal(updatedRows);
            return updatedRows;
        });
    };

    const calculateRowValues = (row) => {
        const qty = parseFloat(row.quantity) || 0;
        const rate = parseFloat(row.amount_in_inr) || 0;
        const gst = parseFloat(row.gst_rate) || 0;
        const discount = parseFloat(row.discount) || 0;

        const baseAmount = qty * rate; // before discount
        const discountAmount = discount; // flat discount
        const total_amount = Math.max(baseAmount - discountAmount, 0); // after discount
        const gstAmount = total_amount * (gst / 100);
        const total = total_amount + gstAmount; // final row total

        return { baseAmount, discountAmount, total_amount, gstAmount, total };
    };

    const calculateSubTotal = (updatedRows) => {
        let totalBeforeDiscount = 0;
        let totalDiscount = 0;
        let totalGST = 0;
        let totalAfterAll = 0;

        updatedRows.forEach((row) => {
            const { baseAmount, discountAmount, gstAmount, total } = calculateRowValues(row);
            totalBeforeDiscount += baseAmount;
            totalDiscount += discountAmount;
            totalGST += gstAmount;
            totalAfterAll += total;
        });

        setTotals({
            beforeDiscount: totalBeforeDiscount,
            discount: totalDiscount,
            gst: totalGST,
            afterAll: totalAfterAll,
        });
    };

    const handleSave = async () => {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        if (!storedToken) {
            alert("You must be logged in to save data.");
            return;
        }

        if (rows.length === 0) {
            alert("No data to save. Please add rows before saving.");
            return;
        }

        const validRows = rows.filter(r => r.desc_id && r.desc_id !== 0);

        if (validRows.length === 0) {
            alert("No valid rows to save. Please select description.");
            return;
        }


        try {

            const updatedRows = validRows.map((r) => {
                const matchedDesc = descriptionsName.find((d) => d.desc_id === r.desc_id);
                const baseAmount = (r.quantity || 1) * (r.amount_in_inr || 0) - (r.discount || 0); // ✅ discount applied
                const gst_amount = baseAmount * ((r.gst_rate || 0) / 100);
                const total_amount = baseAmount;

                return {
                    ...r,
                    location: firstItem.location_id,
                    gst_price: gst_amount,
                    total_amount,
                    total: baseAmount + gst_amount,
                    hsn_sac: matchedDesc ? matchedDesc.hsn : "",

                };
            });

            /* neeed toooo reeevieww */
            const total_quantity = validRows.reduce(
                (sum, r) => sum + (Number(r.quantity) || 0),
                0
            );

            const total_gst_rate = 0;



            const response = await axios.post(
                `${baseAPI}userpost/InsertSow_India`,
                {
                    relocation_id: Relocation_ID,
                    location: firstItem.location_id,
                    origin_port: firstItem.origin_port,
                    destination_port: firstItem.destination_port,
                    buying: firstItem.buying || 0,
                    due_carrier: firstItem.due_carrier || 0,
                    other_charges: firstItem.other_charges || 0,
                    quantity: total_quantity,
                    amount_in_inr: totals.beforeDiscount,  // ✅ before discount
                    gst_rate: total_gst_rate,
                    total: totals.afterAll,                // ✅ use final total
                    total_amount: totals.beforeDiscount,   // or totals.afterAll (depends on your API expectation)
                    total_discount: totals.discount,
                    total_gst: totals.gst,
                    amount_in_aed: firstItem.amount_in_aed || 0,
                    adjustment: adjustment,
                    adjustmentBase: adjustmentBase,
                    adjustmentGST: adjustmentGST,
                    finalAfterAdjustment: finalAfterAdjustment,

                    payment_gateway_percent: paymentPercent,
                    payment_gateway_charges: paymentGatewayCharges,
                    total_after_gateway: finalAfterGateway,

                    rowss: updatedRows,
                },
                {
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                alert("Data saved successfully!!.... Please proceed to generate and download the quotation.");
                setHasSaved(true);
            } else {
                alert("Failed to save data. Please try again.");
            }
        } catch (error) {
            console.error("Error saving data:", error);
            alert("An error occurred while saving the data. Please try again.");
        }
    };

    const handleCitySelect = (selectedCode) => {
        setFirstItem((prev) => ({
            ...prev,
            location_id: selectedCode,
        }));
    };

    const fetchAirport = async () => {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        try {
            const response = await axios.get(
                `${baseAPI}AdminGet/GetAirport?opt=4&Airport_Id=0&search_string1=&search_string2=`,
                {
                    headers: { Authorization: `Bearer ${storedToken}` },
                }
            );
            setOriginAirport(response.data.data || []);
            setDestinationAirport(response.data.data || []);
        } catch (error) {
            console.error("Error fetching airport name:", error);
            setOriginAirport([]);
            setDestinationAirport([]);
        }
    };

    const fetchLane = async (origin, destination) => {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        try {
            const response = await axios.get(
                `${baseAPI}AdminGet/GetLane?origin_code=${origin}&destination_code=${destination}`,
                {
                    headers: { Authorization: `Bearer ${storedToken}` },
                }
            );

            if (response.data?.data?.length > 0) {
                setFirstItem((prev) => ({
                    ...prev,
                    laneName: response.data.data[0].lane, // save this too
                }));
            } else {
                setFirstItem((prev) => ({
                    ...prev,
                    laneName: "NA", // save this too
                }));
            }
        } catch (error) {
            console.error("Error fetching lane:", error);
            setFirstItem((prev) => ({
                ...prev,
                laneName: "NA", // save this too
            }));
        }
    };

    const handleAirportChange = (field, value) => {
        setFirstItem((prev) => {
            const updated = { ...prev, [field]: value };

            // ✅ Only call lane API if both origin & destination are selected
            if (updated.origin_port !== "0" && updated.destination_port !== "0") {
                fetchLane(updated.origin_port, updated.destination_port);
            } else {
                setFirstItem((prev) => ({
                    ...prev,
                    laneName: "NA", // save this too
                }));
            }
            return updated;
        });
    };

    // useEffect(() => {
    //     if (adjustment > 0) {
    //         const base = adjustment / 1.12;
    //         const gst = adjustment - base;
    //         setAdjustmentBase(base);
    //         setAdjustmentGST(gst);
    //         setFinalAfterAdjustment(totals.afterAll - adjustment);
    //     } else {
    //         setAdjustmentBase(0);
    //         setAdjustmentGST(0);
    //         setFinalAfterAdjustment(totals.afterAll);
    //     }
    // }, [adjustment, totals]);

    // useEffect(() => {
    //     const base = Number(finalAfterAdjustment) || 0;
    //     const pct = Number(paymentPercent) || 0;
    //     const pgCharges = +(base * (pct / 100)); // numeric
    //     const finalTotal = base + pgCharges;

    //     setPaymentGatewayCharges(pgCharges);
    //     setFinalAfterGateway(finalTotal);
    // }, [paymentPercent, finalAfterAdjustment]);


    useEffect(() => {
        const totalAfterAll = Number(totals?.afterAll) || 0;

        // Adjustment calculations
        let adjBase = 0;
        let adjGst = 0;
        let finalAfterAdj = totalAfterAll;

        if (Number(adjustment) > 0) {
            adjBase = Number(adjustment) / 1.18;
            adjGst = Number(adjustment) - adjBase;
            finalAfterAdj = totalAfterAll - Number(adjustment);
        }

        // Update adjustment-related state
        setAdjustmentBase(adjBase);
        setAdjustmentGST(adjGst);
        setFinalAfterAdjustment(finalAfterAdj);

        // Payment gateway calculations (use the freshly computed finalAfterAdj)
        const pct = Number(paymentPercent) || 0;
        const pgCharges = +(finalAfterAdj * (pct / 100));
        const finalTotal = finalAfterAdj + pgCharges;

        setPaymentGatewayCharges(pgCharges);
        setFinalAfterGateway(finalTotal);

    }, [adjustment, totals?.afterAll, paymentPercent]);


    return (
        <>
            <div className="app-container-PriceCalculator">
                <MiniDrawer />
                <div className="container-fluid container-PriceCalculator">
                    <div className="country-header">
                        <div>
                            <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                                Price Calculator| <HomeOutlinedIcon />{" "}
                                <span style={{ fontSize: "20px" }}>&gt; Price Calculator</span>
                            </h1>
                        </div>
                    </div>
                    <Wrapper className="PriceCalculator">
                        <div className="viewLeadDetails-form">
                            <table
                                style={{
                                    width: "100%",
                                    color: "#6A6A6A",

                                    borderRadius: "12px",
                                }}
                            >
                                <tr className="viewLeadDetailsHeading">
                                    <th
                                        colSpan={8}
                                        style={{
                                            background: "#5B489D",
                                            color: "white",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            <span style={{ fontSize: "18px" }}>Details</span>
                                            <span style={{ fontSize: "18px", padding: "0 10px" }}>
                                                {/* <a
                                                    href="/CheckHistory"
                                                    onClick={handleCheckHistory}
                                                    style={{
                                                        color: "white",
                                                        textDecoration: "underline",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Check Estimate History
                                                </a> */}

                                                <a
                                                    href="#"
                                                    onClick={handleCheckHistory}
                                                    style={{
                                                        color: "white",
                                                        textDecoration: "underline",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Check Estimate History
                                                </a>


                                            </span>
                                        </div>
                                    </th>
                                </tr>
                                <tr className="viewLeadDetailsHeading">
                                    <th colSpan={2}>
                                        <span>Lead ID & Lead Owner</span>
                                    </th>
                                    <td colSpan={2}>
                                        <span style={{ fontWeight: "bold" }}>{firstItem.relocation_id} - {firstItem.lead_owner} </span>
                                    </td>
                                    <th colSpan={2}>
                                        <span>Name</span>
                                    </th>
                                    <td colSpan={2}>
                                        <span>{firstItem.name}</span>
                                    </td>
                                </tr>

                                <tr className="viewLeadDetailsHeading">
                                    <th colSpan={2}>
                                        <span>Service Type</span>
                                    </th>
                                    <td colSpan={2}>
                                        <span>{firstItem.ServiceTypeName}</span>
                                    </td>
                                    <th colSpan={2}>
                                        <span>Delivery Type</span>
                                    </th>
                                    <td colSpan={2}>
                                        <span>{firstItem.delivery_type_name}</span>
                                    </td>
                                </tr>
                                <tr className="viewLeadDetailsHeading">
                                    <th colSpan={2}>
                                        <span>From City</span>
                                    </th>
                                    <td colSpan={2}>
                                        <span>{firstItem.origin_city1}</span>
                                    </td>
                                    <th colSpan={2}>
                                        <span>To City</span>
                                    </th>
                                    <td colSpan={2}>
                                        <span>{firstItem.destination_city1}</span>
                                    </td>
                                </tr>
                                <tr className="viewLeadDetailsHeading">
                                    <th colSpan={2}>
                                        <span>Mode of Transportation</span>
                                    </th>
                                    <td colSpan={2}>
                                        <span>{firstItem.mode_of_transport_name}</span>
                                    </td>
                                    <th colSpan={2}>
                                        <span>Number of Pets</span>
                                    </th>
                                    <td colSpan={2}>
                                        <span>{firstItem.number_of_pets}</span>
                                    </td>
                                </tr>
                                <tr className="viewLeadDetailsHeading">
                                    <th colSpan={2}>
                                        <span>Pet Type</span>
                                    </th>
                                    <td colSpan={2}>
                                        <span>{firstItem.pettype}</span>
                                    </td>
                                    <th colSpan={2}>
                                        <span>Pet Breed</span>
                                    </th>
                                    <td colSpan={2}>
                                        <span>{firstItem.petbreedtype}</span>
                                    </td>
                                </tr>
                                <tr className="viewLeadDetailsHeading">
                                    <th colSpan={2}>
                                        <span>Job Type</span>
                                    </th>
                                    <td colSpan={2}>
                                        <span>{firstItem.job_type}</span>
                                    </td>
                                    <th colSpan={2}>
                                        <span>Location</span>
                                    </th>
                                    <td colSpan={2}>
                                        <select
                                            value={firstItem.location_id}
                                            onChange={(e) => handleCitySelect(e.target.value)}
                                        >
                                            <option value="">Select City</option>
                                            {locations.map((loc) => (
                                                <option key={loc.location_id} value={loc.location_id} >
                                                    {loc.location}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr className="viewLeadDetailsHeading">
                                    <th colSpan={2}>
                                        <span>Origin Airport</span>
                                    </th>
                                    <td colSpan={2}>
                                        <select
                                            name="origin_port"
                                            value={firstItem.origin_port}
                                            onChange={(e) =>
                                                handleAirportChange("origin_port", e.target.value)
                                            }
                                        >
                                            <option value="0">Select an option</option>
                                            {originAirport?.length > 0 ? (
                                                originAirport.map((item) => (
                                                    <option
                                                        key={item.Airport_Code}
                                                        value={item.Airport_Code}
                                                    >
                                                        {item.Airport_Name}
                                                    </option>
                                                ))
                                            ) : (
                                                <option value="-1">NA</option>
                                            )}
                                        </select>
                                    </td>

                                    <th colSpan={2}>
                                        <span>Destination Airport</span>
                                    </th>
                                    <td colSpan={2}>
                                        <select
                                            name="destination_port"
                                            value={firstItem.destination_port}
                                            onChange={(e) =>
                                                handleAirportChange("destination_port", e.target.value)
                                            }
                                        >
                                            <option value="0">Select an option</option>
                                            {destinationAirport?.length > 0 ? (
                                                destinationAirport.map((item) => (
                                                    <option
                                                        key={item.Airport_Code}
                                                        value={item.Airport_Code}
                                                    >
                                                        {item.Airport_Name}
                                                    </option>
                                                ))
                                            ) : (
                                                <option value="-1">NA</option>
                                            )}
                                        </select>
                                    </td>
                                </tr>
                                <tr className="viewLeadDetailsHeading">
                                    <th colSpan={2}>
                                        <span>Lane</span>
                                    </th>
                                    <td colSpan={2}>
                                        <span>{firstItem.laneName}</span>
                                    </td>
                                    <th colSpan={2}>Amount in AED (If Any)</th>
                                    <td colSpan={2}>
                                        {/* <input type="number" value={firstItem.amount_in_aed || "0"} id="amount_in_aed" name="amount_in_aed"
                                            onChange={(e) => setFirstItem((prev) => ({ ...prev, amount_in_aed: e.target.value, }))} /> */}
                                        <NumericInput
                                            value={firstItem.amount_in_aed ?? ""}
                                            id="amount_in_aed" name="amount_in_aed"
                                            onChange={(val) => setFirstItem((prev) => ({ ...prev, amount_in_aed: val }))}
                                            allowDecimal={true}
                                            allowNegative={false}
                                            maxDigits={9}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <th style={{ textAlign: "left", width: "12%" }}>Chargeable Weight: </th>
                                    <td style={{ textAlign: "left", fontWeight: "bold", width: "13%" }}>{firstItem.chargeable_wt}</td>
                                    <th style={{ textAlign: "left", width: "12%" }}>Buying: </th>
                                    <td style={{ width: "13%" }}>
                                        {/* <input type="number" value={firstItem.buying || "0"} id="buying" name="buying"
                                            onChange={(e) => setFirstItem((prev) => ({ ...prev, buying: e.target.value, }))} /> */}

                                        <NumericInput value={firstItem.buying || "0"} id="buying" name="buying"
                                            onChange={(val) => setFirstItem((prev) => ({ ...prev, buying: val, }))}
                                            allowDecimal={true}
                                            allowNegative={false}
                                            maxDigits={9}
                                        />


                                    </td>
                                    <th style={{ textAlign: "left", width: "12%" }}>Due Carrier: </th>
                                    <td style={{ width: "13%" }}>
                                        {/* <input type="number" value={firstItem.due_carrier || "0"} id="due_carrier" name="due_carrier"
                                            onChange={(e) => setFirstItem((prev) => ({ ...prev, due_carrier: e.target.value, }))} /> */}
                                        <NumericInput value={firstItem.due_carrier || "0"} id="due_carrier" name="due_carrier"
                                            onChange={(val) => setFirstItem((prev) => ({ ...prev, due_carrier: val, }))}
                                            allowDecimal={true}
                                            allowNegative={false}
                                            maxDigits={9}
                                        />

                                    </td>
                                    <th style={{ textAlign: "left", width: "12%" }}>Other Charges: </th>
                                    <td style={{ width: "13%" }} >
                                        {/* <input type="number" value={firstItem.other_charges || "0"} id="other_charges" name="other_charges"
                                        onChange={(e) => setFirstItem((prev) => ({ ...prev, other_charges: e.target.value, }))} /> */}

                                        <NumericInput value={firstItem.other_charges || "0"} id="other_charges" name="other_charges"
                                            onChange={(val) => setFirstItem((prev) => ({ ...prev, other_charges: val, }))}
                                            allowDecimal={true}
                                            allowNegative={false}
                                            maxDigits={9}
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </Wrapper>
                    <br />
                    <Wrapper className="ViewLeadDetails">
                        <div className="container-fluid">
                            <div>
                                <table border="1" width="100%">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "2%" }}>S No.</th>
                                            <th style={{ width: "15%" }}>Description</th>
                                            <th style={{ width: "18%" }}>Scope of Service</th>
                                            <th style={{ width: "7%" }}>Quantity</th>
                                            <th style={{ width: "10%" }}>Rate</th>
                                            <th className="d-none" style={{ width: "8%" }}>Discount (INR)</th>
                                            <th style={{ width: "7%" }}>Taxable Amount</th>
                                            <th style={{ width: "5%" }}>Rate Gst</th>
                                            <th style={{ width: "10%" }}>Total</th>
                                            <th style={{ width: "3%" }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows && rows.length > 0 ? (
                                            rows.map((row, index) => (
                                                <tr key={index} style={{ borderBottom: "0.4px solid lightgray" }}>
                                                    <td>{index + 1}</td>

                                                    {/* Description */}
                                                    <td>
                                                        <select
                                                            value={row.desc_id || ""}
                                                            onChange={(e) => handleSelectChange(e, index)}
                                                            style={{ width: "100%" }}
                                                        >
                                                            <option>Select</option>
                                                            {descriptionsName.map((desc) => (
                                                                <option key={desc.desc_id} value={desc.desc_id}>
                                                                    {desc.description_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    {/* Scope of Service */}
                                                    <td>
                                                        <textarea
                                                            value={row.scope_of_service || ""}
                                                            onChange={(e) =>
                                                                handleInputChange(
                                                                    index,
                                                                    "scope_of_service",
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                width: "100%",
                                                                minHeight: "40px",
                                                                resize: "vertical", // allows resizing vertically
                                                                fontSize: "15px",

                                                            }}
                                                        />
                                                    </td>

                                                    {/* Quantity */}
                                                    <td>
                                                        {/* <input type="number" value={row.quantity || ""} onChange={(e) => handleInputChange(index, "quantity", e.target.value)} style={{ width: "100%" }} /> */}

                                                        <NumericInput value={row.quantity || ""} onChange={(val) => handleInputChange(index, "quantity", val)}
                                                            style={{ width: "100%" }} allowDecimal={true}
                                                            allowNegative={false} maxDigits={4} />
                                                    </td>

                                                    {/* Amount */}
                                                    <td>
                                                        {/* <input type="number" value={row.amount_in_inr || ""} onChange={(e) => handleInputChange(index, "amount_in_inr", e.target.value)} style={{ width: "100%" }} />
                                                     */}
                                                        <NumericInput value={row.amount_in_inr || ""} onChange={(val) => handleInputChange(index, "amount_in_inr", val)}
                                                            style={{ width: "100%" }} allowDecimal={true}
                                                            allowNegative={false} maxDigits={9} />

                                                    </td>

                                                    {/* Discount */}
                                                    <td className="d-none">
                                                        {/* <input type="number" value={row.discount || ""} onChange={(e) => handleInputChange(index, "discount", e.target.value)} style={{ width: "100%" }} />
                                                    */}
                                                        <NumericInput value={row.discount || ""} onChange={(val) => handleInputChange(index, "discount", val)}
                                                            style={{ width: "100%" }} allowDecimal={true}
                                                            allowNegative={false} maxDigits={9} />

                                                    </td>
                                                    <td>{row.total_amount ? row.total_amount.toFixed(2) : "0.00"}</td>


                                                    {/* GST Rate */}
                                                    <td>
                                                        {/* <input type="number" value={row.gst_rate || ""} onChange={(e) => handleInputChange(index, "gst_rate", e.target.value)} style={{ width: "100%" }} />
                                                     */}
                                                        <NumericInput value={row.gst_rate || ""} onChange={(val) => handleInputChange(index, "gst_rate", val)}
                                                            style={{ width: "100%" }} allowDecimal={true}
                                                            allowNegative={false} maxDigits={3} />


                                                    </td>

                                                    {/* Total */}
                                                    <td>{row.total ? row.total.toFixed(2) : "0.00"}</td>

                                                    {/* Actions */}
                                                    <td style={{ textAlign: "center" }}>
                                                        <button
                                                            style={{ height: "36px", width: "44px" }}
                                                            onClick={() => handleDeleteRow(index)}
                                                        >
                                                            <MdDelete
                                                                className="icon"
                                                                style={{
                                                                    color: "red",
                                                                    height: "32px",
                                                                    width: "29px",
                                                                }}
                                                            />
                                                        </button>
                                                    </td>
                                                </tr>

                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="8" style={{ textAlign: "center" }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                    <tfoot>
                                        <tr className="d-none">
                                            <td colSpan={8} style={{ textAlign: "right" }}>Total Before Discount</td>
                                            <td colSpan={2}>{totals.beforeDiscount.toFixed(2)}</td>
                                        </tr>
                                        <tr className="d-none">
                                            <td colSpan={8} style={{ textAlign: "right" }}>Total Discount</td>
                                            <td colSpan={2}>-{totals.discount.toFixed(2)}</td>
                                        </tr>
                                        <tr className="d-none">
                                            <td colSpan={8} style={{ textAlign: "right" }}>Total GST</td>
                                            <td colSpan={2}>{totals.gst.toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={8} style={{ textAlign: "right", fontWeight: "bold" }}>
                                                Total
                                            </td>
                                            <td colSpan={2} style={{ fontWeight: "bold" }}>
                                                {totals.afterAll.toFixed(2)}
                                            </td>
                                        </tr>


                                        <tr>
                                            <td colSpan={8} style={{ textAlign: "right" }}>Discount (Incl. GST)</td>
                                            <td colSpan={2}>
                                                {/* <input
                                                    type="number"
                                                    value={adjustment}
                                                    style={{ width: "100%" }}
                                                    onChange={(e) => {
                                                        const adj = parseFloat(e.target.value) || 0;
                                                        setAdjustment(adj);
                                                        if (adj > 0) {
                                                            const base = adj / 1.12;
                                                            const gst = adj - base;
                                                            setAdjustmentBase(base);
                                                            setAdjustmentGST(gst);
                                                            setFinalAfterAdjustment(totals.afterAll - adj);
                                                        } else {
                                                            setAdjustmentBase(0);
                                                            setAdjustmentGST(0);
                                                            setFinalAfterAdjustment(totals.afterAll);
                                                        }
                                                    }}
                                                /> */}

                                                <NumericInput
                                                    value={adjustment}
                                                    style={{ width: "100%" }}
                                                    allowDecimal={true}
                                                    allowNegative={false} maxDigits={12}
                                                    onChange={(val) => {
                                                        const adj = parseFloat(val) || 0;
                                                        setAdjustment(adj);
                                                        if (adj > 0) {
                                                            const base = adj / 1.18;
                                                            const gst = adj - base;
                                                            setAdjustmentBase(base);
                                                            setAdjustmentGST(gst);
                                                            setFinalAfterAdjustment(totals.afterAll - adj);
                                                        } else {
                                                            setAdjustmentBase(0);
                                                            setAdjustmentGST(0);
                                                            setFinalAfterAdjustment(totals.afterAll);
                                                        }
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={8} style={{ textAlign: "right" }}>Discount Base (Excl. GST)</td>
                                            <td colSpan={2}>{adjustmentBase.toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={8} style={{ textAlign: "right" }}>Discount GST (18%)</td>
                                            <td colSpan={2}>{adjustmentGST.toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={8} style={{ textAlign: "right", fontWeight: "bold", color: "darkgreen" }}>
                                                Total After Discount (in round off)
                                            </td>
                                            <td colSpan={2} style={{ fontWeight: "bold", color: "darkgreen" }}>
                                                {Math.round(finalAfterAdjustment)}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td colSpan={7} style={{ textAlign: "right" }}>Payment Gateway Charges (%)</td>
                                            <td colSpan={1}>
                                                {/* <input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    value={paymentPercent}
                                                    style={{ width: "100%" }}
                                                    onChange={(e) => {
                                                        const val = parseFloat(e.target.value);
                                                        setPaymentPercent(isNaN(val) ? 0 : val);
                                                    }}
                                                /> */}

                                                <NumericInput
                                                    value={paymentPercent ?? ""}
                                                    onChange={(val) => {
                                                        const p = parseFloat(val);
                                                        setPaymentPercent(isNaN(p) ? 0 : p);
                                                    }}
                                                    allowDecimal={true}
                                                    allowNegative={false}
                                                    maxDigits={6}
                                                    style={{ width: "100%" }}
                                                />
                                            </td>
                                            <td colSpan={2}>{paymentGatewayCharges ? paymentGatewayCharges.toFixed(2) : "0.00"}</td>
                                        </tr>

                                        {/* NEW: Final after gateway charges (rounded) */}
                                        <tr>
                                            <td colSpan={8} style={{ textAlign: "right", fontWeight: "bold", color: "darkblue" }}>
                                                Final Total After Gateway Charges (rounded)
                                            </td>
                                            <td colSpan={2} style={{ fontWeight: "bold", color: "darkblue" }}>
                                                {Math.round(finalAfterGateway)}
                                            </td>
                                        </tr>



                                    </tfoot>
                                </table>
                                <div>
                                    {!hasRows && !hasSaved && (
                                        <button onClick={handleAddRow}>Add Row</button>
                                    )}
                                    {hasRows && !hasSaved && (
                                        <>
                                            <button onClick={handleAddRow}>Add Row</button>
                                            <button onClick={handleSave} style={{ marginLeft: "10px" }}>Save</button>
                                        </>
                                    )}
                                    {hasSaved && (
                                        <>
                                            <button onClick={handleAddRow}>Add Row</button>
                                            <button onClick={handleSave} style={{ marginLeft: "10px" }}>Save</button>
                                            <button onClick={handleQuotation} style={{ marginLeft: "10px" }}>
                                                Get Quotation
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </div>
            </div>
            {hasSaved && (
                <div style={{
                    position: "fixed",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    backgroundColor: "#fff3cd",
                    color: "#856404",
                    padding: "12px 20px",
                    borderTop: "1px solid #ffeeba",
                    boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
                    zIndex: 9999,
                    textAlign: "center",
                    fontSize: "14px",
                    fontWeight: "500"
                }}>
                    ⚠️ After clicking <b>Save</b>, please go to <b>Get Quotation</b> and click <b>Publish to PDF</b>.
                    Only then the PDF will be generated.
                </div>
            )}
        </>
    );
};

export default RateCalculatorIndia;
